import type { AxiosError } from "axios"
import ApplicationError from "../error/ApplicationError.js"
import ErrorCode from "../error/ErrorCode.js"
import type HTTPResponse from "../http/HTTPResponse.js"

/**
 * @description
 *	An HTTP client error generated after trying to send a request to an
 *	external server.
 */
export default class HTTPClientError extends ApplicationError<{
	cause: unknown
	code: string | undefined
	message: string
	response: HTTPResponse<unknown> | undefined
}> {
	public constructor(error: AxiosError, response: HTTPResponse<unknown> | undefined) {
		super(
			ErrorCode.HTTPClientError,
			`Inner HTTP client (Axios), failed to deliver the request (${error.code}: ${error.message}).`,
			{
				cause: error.cause,
				code: error.code,
				message: error.message,
				response
			},
			error.stack
		)
	}
}
